import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { OmsBookableChecksComponent } from '../../src/views/dashboard/components/oms-bookable-checks/oms-bookable-checks.component';
import { AdminFollowUp } from './components/admin_follow_up/admin-follow-up.component';
import { AgencySelfServiceForm } from './components/admin_follow_up/agency-self-service-form.compontent';
import { AutomaticMmsGainToggle } from './components/admin_follow_up/automatic-mms-gain-toggle.component';
import { FrequencyLimit } from './components/admin_follow_up/frequency-limit.component';
import { CreateCampaignFromTemplateButton } from './components/buttons/create-campaign-from-template-button.component';
import { DownloadOutcomeButton } from './components/buttons/download-outcome-button.component';
import { CampaignApprovalList } from './components/campaign_approval/campaign-approval-list.component';
import { CampaignGoalsComponent } from './components/campaign_goals/campaign-goals.component';
import { EditGoalForm } from './components/campaign_goals/edit-goal-form.component';
import { EditTargetingForm } from './components/campaign_goals/edit-targeting-form.component';
import { CampaignHistory } from './components/campaign_history/campaign-history.component';
import { CampaignInventoryComponent } from './components/campaign_inventory/campaign-inventory.campaign';
import { DashboardCampaigns } from './components/campaigns/dashboard-campaigns.component';
import { Dashboard } from './components/dashboard/dashboard.component';
import { DashboardSidebar } from './components/dashboard_sidebar/dashboard-sidebar.component';
import { CancelCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/cancel-campaign-button.component';
import { CloseCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/close-campaign-button.component';
import { DuplicateCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/duplicate-campaign-button.component';
import { EditCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/edit-campaign-button.component';
import { ManageCampaignButtons } from '@scripts/woo_dashboard.module/components/dashboard_sidebar/manage_campaign_buttons/manage-campaign-buttons/manage-campaign-buttons.component';
import { RemoveCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/remove-campaign-button.component';
import { ReviewCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/review-campaign-button.component';
import { SendToAdServerButton } from './components/dashboard_sidebar/manage_campaign_buttons/send-to-ad-server-button.component';
import { StopCampaignButton } from './components/dashboard_sidebar/manage_campaign_buttons/stop-campaign-button.component';
import { ViewCurrencyBlock } from './components/dashboard_sidebar/view_currency_block/view-currency-block.component';
import { DashboardDetails } from './components/details/dashboard-details.component';
import { EditGoals } from './components/edit_goals/edit-goals.component';
import { ExtendCampaign } from './components/extend_campaign/extend-campaign.component';
import { FollowUp } from './components/follow_up/follow-up.component';
import { InvoiceForm } from './components/invoices/invoice-form.component';
import { Invoices } from './components/invoices/invoices.component';
import { CampaignOutcome } from './components/outcome/campaign-outcome.component';
import { EditOutcomeReport } from './components/outcome/edit_outcome_report/edit-outcome-report.component';
import { MMSTotalsSummary } from './components/outcome/mms-totals-summary.component';
import { Outcome } from './components/outcome/outcome.component';
import { TargetingOutcomeSummary } from './components/outcome/targeting-outcome-summary.component';
import { TargetingOutcome } from './components/outcome/targeting-outcome.component';
import { TrackingDistribution } from './components/outcome/tracking-distribution.component';
import { TvDayOutcome } from './components/outcome/tv-day-outcome.component';
import { TvDayOutcomeTable } from './components/outcome/tv_day_outcome_table/tv-day-outcome-table.component';
import { TrackingService } from './services/TrackingService';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TrackingDistribution,
    DotLoader,
    OmsBookableChecksComponent,
    WooComponentsModule,
  ],
  providers: [TrackingService],
  declarations: [
    Dashboard,
    AdminFollowUp,
    AutomaticMmsGainToggle,
    CampaignApprovalList,
    CampaignGoalsComponent,
    CampaignHistory,
    CampaignInventoryComponent,
    CampaignOutcome,
    DashboardCampaigns,
    CreateCampaignFromTemplateButton,
    CancelCampaignButton,
    CloseCampaignButton,
    DashboardDetails,
    DashboardSidebar,
    DownloadOutcomeButton,
    DuplicateCampaignButton,
    EditCampaignButton,
    EditGoalForm,
    EditGoals,
    EditOutcomeReport,
    EditTargetingForm,
    ExtendCampaign,
    FollowUp,
    FrequencyLimit,
    InvoiceForm,
    Invoices,
    ManageCampaignButtons,
    MMSTotalsSummary,
    Outcome,
    RemoveCampaignButton,
    ReviewCampaignButton,
    SendToAdServerButton,
    StopCampaignButton,
    TargetingOutcome,
    TargetingOutcomeSummary,
    TvDayOutcome,
    TvDayOutcomeTable,
    ViewCurrencyBlock,
    AgencySelfServiceForm,
  ],
  exports: [
    CampaignApprovalList,
    CampaignHistory,
    DashboardDetails,
    DashboardSidebar,
    EditGoals,
    ExtendCampaign,
    Outcome,
    FollowUp,
    AdminFollowUp,
  ],
})
export class WooDashboardModule {}
